import { useQuery } from '@tanstack/react-query';
import { standalone } from '../api/methods';
export const dashboardKeys = {
    all: ['dashboard'],
    personal: ['dashboard', 'personal'],
    myTicketsAll: ['dashboard', 'myTickets'],
    myTickets: (params = {}) => ['dashboard', 'myTickets', params.scope || 'me', params.status || 'all'],
};
export function useDashboard() {
    return useQuery({
        queryKey: dashboardKeys.personal,
        queryFn: () => standalone.getDashboard(),
        // A 4xx here is deterministic — most importantly 428 `trello_not_linked`,
        // which must surface its "link your Trello account" prompt immediately.
        // Retrying it is pointless and opens a window where a transient 5xx (e.g. a
        // deploy container swap) lands on the final attempt and masks the 428 as a
        // generic error. Only retry genuine 5xx/network failures, once.
        retry: (failureCount, error) => {
            const status = error?.status;
            if (typeof status === 'number' && status >= 400 && status < 500)
                return false;
            return failureCount < 1;
        },
    });
}
export function useMyTickets(params = {}) {
    return useQuery({
        queryKey: dashboardKeys.myTickets(params),
        queryFn: () => standalone.getMyTickets(params),
    });
}
//# sourceMappingURL=useDashboard.js.map